import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container pt-5 text-start" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Ikke påmeldt", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Du er ikke påmeldt Klatrekongen. Du har kansellerte påmeldingen. ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Var dette en feil?   Meld deg på ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" her")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Ikke påmeldt", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Du har ikke blitt påmeldt Klatrekongen. Du huket ikke av på \"View data about your activities\". ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Dette må vi ha tilgang til for å innhente tidene dine for segmentene i konkurransen. ", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Var dette en feil?   Meld deg på ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" her")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Du er påmeldt!", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Gratulerer,  du er herved påmeldt Klatrekongen!", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Vi vil nå innhente nødvendig data, for å legge tidene dine til i resultatlistene.   Dette skjer fortløpende og kan ta noe tid avhenging av kapasiet. ", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Lykke til og gi gass!   Sjekk ut ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("resultatlistene her.")
const _hoisted_21 = { key: 3 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Systemfeil", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, " Det har skjedd en feil i vårt system og du er ikke meldt på Klatrekongen. ", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Prøv igjen ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" her")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("!   Får du fortsatt denne meldingen,  ta kontakt på ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:mail@klatrekongen.no" }, "mail@klatrekongen.no", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Du er allerede påmeldt", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Du har allerede opprettet en bruker og finnes i vårt system.", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Har du noen spørsmål,   ta kontakt på "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:mail@klatrekongen.no" }, "mail@klatrekongen.no"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_33 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 5,
  class: "loader mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", null, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              class: "fw-bold",
              to: "/registration"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.scope)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("p", null, [
            _hoisted_12,
            _createVNode(_component_router_link, {
              class: "fw-bold",
              to: "/registration"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.code)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("p", null, [
            _hoisted_19,
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.systemfail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("p", null, [
            _hoisted_24,
            _createVNode(_component_router_link, {
              class: "fw-bold",
              to: "/registration"
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }),
            _hoisted_26,
            _hoisted_27,
            _hoisted_28
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userExist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_33))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34))
      : _createCommentVNode("", true)
  ]))
}